export interface PlaceOrderInput {
  checkout_id: string;
  created_via: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_campaign_id?: string;
  utm_adset_id?: string;
  utm_ad_id?: string;
  fbclid?: string;
}

export interface cancelOrderInput {
  order_id: string;
  reason: string;
  comment:string | null;
}
export interface ErrorResponse {
  success: false;
  message: string;
}

export interface addressCheckout {
  address_id: string
}
export interface paymentSetupCheckout {
  payment_method_id: string
}
export interface requestOrder {
  page: number,
  limit: number,
  filters: any
};
export interface requestReturn {
  order_id: string,
  order_items: {
    order_item_id:string,
    reason:string,
    comment:string,
    quantity?:number
  }[]
};
export interface cancelInput {
  order_id: string,
  new_status: string,
};
export interface returnApproveRequest {
  id: string,
  order_id: string,
  reject_reason?:string
};
export interface orderStatusInput {
  new_status: string,
};
export interface AdminOrderAddressInput {
  first_name:string;
  last_name:string;
  email: string;
  mobile: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state:string;
  country: string;
  note?: string;      // optional
  latitude?: number;
  longitude?: number;
}

export interface shippingOrderInput {
  order_id: string,
  shipping_company_id:string;
};

export interface bulkOrderInput {
  updates: {
    order_id: string;
    new_status: string;
  }[];
};